import { useListItem } from "@floating-ui/react";
import c from "classnames";
import { ReactNode, useContext } from "react";

import { Clickable } from "@design-system/Clickable/Clickable";

import { GlobalSearchContext } from "./GlobalSearchContext";

import classes from "./GlobalSearch.module.css";

type Props = {
  id: string;
  label: string;
  onSelect: () => void;
  children: ReactNode;
};

/**
 * Registers a suggestion with Floating UI list navigation so mouse and
 * keyboard selection share the same navigation path.
 */
export const GlobalSearchOption = ({
  id,
  label,
  onSelect,
  children,
}: Props) => {
  const { activeIndex, selectedIndex, getItemProps, handleSelect } =
    useContext(GlobalSearchContext);

  const { ref, index } = useListItem({ label });

  const isActive = activeIndex === index;
  const isSelected = selectedIndex === index;

  return (
    <div className={c(classes.option, isActive && classes.optionActive)}>
      <Clickable
        padding={0}
        ref={ref}
        role="option"
        aria-selected={isActive && isSelected}
        tabIndex={isActive ? 0 : -1}
        outline="xs"
        stretch
        {...getItemProps({
          onClick: () => {
            onSelect();
            handleSelect(id, index);
          },
        })}
      >
        {children}
      </Clickable>
    </div>
  );
};
